import { LoadingContainer, Modal, Input, Select } from 'peach/components'
import { ListSubroutes, useParams } from 'peach/router'

import { Page } from 'core/components'
import { useInvestorGetAll, useInvestorCreate } from 'core/types'

const CompanyInvestors = () => {
  const { companyId } = useParams<{ companyId?: string }>()

  const {
    data: investors,
    isLoading,
    refetch,
  } = useInvestorGetAll({ companyId })

  const { mutateAsync: addCompanyInvestor } = useInvestorCreate({ companyId })

  return (
    <LoadingContainer loading={isLoading}>
      <Modal
        onSubmit={async (investor) => {
          await addCompanyInvestor(investor)
          refetch()
        }}
        title='Add Investor'
        trigger
      >
        <Input formKey='legalName' />
        <Select boolean formKey='default' />
      </Modal>
      <Page variant='full'>
        <ListSubroutes
          json={investors}
          paramKey='investorId'
          title='Investors'
        />
      </Page>
    </LoadingContainer>
  )
}

export default CompanyInvestors
